<div>
  @if (pilotBoardingPlaceWarning != null) {
    <div>
      <app-status-alert type="warning">{{ pilotBoardingPlaceWarning }}</app-status-alert>
    </div>
  }
  @if (additionalIncomingMovementInfo.entryDependencyRemarks != null) {
    <div>
      <app-status-alert type="warning">Remarks: <i>{{ additionalIncomingMovementInfo.entryDependencyRemarks }}</i>
      </app-status-alert>
    </div>
  }
  @if (cancellationReason != null) {
    <div>
      <app-status-alert type="danger">Cancellation reason: <i>{{ cancellationReason }}</i></app-status-alert>
    </div>
  }
  @if (incomingMovementHarbourMasterInfo.rejectionReason) {
    <div>
      <app-status-alert type="danger">Harbour master rejection reason:
        <i>{{ incomingMovementHarbourMasterInfo.rejectionReason }}</i></app-status-alert>
    </div>
  }
  @if (incomingMovementHarbourMasterInfo.remarks) {
    <div>
      <app-status-alert type="info">Harbour master remarks: <i>{{ incomingMovementHarbourMasterInfo.remarks.text }}</i>
      </app-status-alert>
    </div>
  }

  @if (getShiftedIncomingOrder) {
    <div>
      <app-status-alert type="warning">Your order of the incoming movement has been confirmed but the arrival time was
        changed.
      </app-status-alert>
    </div>
  }
  @if (movementOnHold) {
    <div>
      <app-status-alert type="warning">Your movement to the first berth has been put on hold by the port authorities and
        may proceed as conditions allow.
      </app-status-alert>
    </div>
  }

  <!-- Display messages when the vessel has an dependency on another vessel -->
  @if (entryDependency) {
    <div>
      @if (isAutoOrdered) {
        <app-status-alert type="info">
          @if (!additionalIncomingMovementInfo.etdChanged && hasVisitDeclarationBeenSavedAndSent()) {
            <span>The incoming movement has been ordered automatically, due to order of the movement of {{ entryDependency.vesselName }}.</span>
          }
          @if (!additionalIncomingMovementInfo.etdChanged && !hasVisitDeclarationBeenSavedAndSent()) {
            <span>The incoming movement can be ordered via “Save and send”, which automatically connects the order to the order of the movement of {{ entryDependency.vesselName }}.</span>
          }
          @if (additionalIncomingMovementInfo.etdChanged) {
            <span>ETA PBP has been changed automatically, due to change of ETD of {{ entryDependency.vesselName }}.</span>
          }
        </app-status-alert>
      } @else {
        @if (portEntryIsOrdered) {
          @if (!orderingPossible && !orderCancelledOrRejected && entryDependency.vesselName) {
            <div>
              <app-status-alert type="warning">
                <span>The movement of {{ entryDependency.vesselName }} has not been ordered yet. Harbour master might reject your order of the incoming movement.</span>
              </app-status-alert>
            </div>
          }
          @if (orderingPossible && !additionalIncomingMovementInfo.etdChanged) {
            <div>
              <app-status-alert type="info">
                <span>The movement of {{ entryDependency.vesselName }} has been ordered. </span>
                @if (!etaPbpIsBeforeEtdBerth) {
                  <span>The incoming movement had already been ordered; no action required.</span>
                }
                @if (etaPbpIsBeforeEtdBerth) {
                  <span>You might have to change your ETA PBP.</span>
                }
              </app-status-alert>
            </div>
          }
          @if (orderingPossible && additionalIncomingMovementInfo.etdChanged) {
            <div>
              <app-status-alert type="info">
                <span>ETD of {{ entryDependency.vesselName }} has been changed. The incoming movement had already been ordered; no action required.</span>
              </app-status-alert>
            </div>
          }
          @if (orderingPossible && additionalIncomingMovementInfo.etaChanged) {
            <div>
              <app-status-alert type="info">
                <span>ETA of {{ entryDependency.vesselName }} has been changed. The incoming movement had already been ordered; no action required.</span>
              </app-status-alert>
            </div>
          }
        } @else {
          @if (orderingPossible && !additionalIncomingMovementInfo.etdChanged) {
            <div>
              <app-status-alert type="info">
                <span>The movement of {{ entryDependency.vesselName }} has been ordered. You may want to order the incoming movement</span>@if (etaPbpIsBeforeEtdBerth) {
                <span>, but you might have to change your ETA PBP then.</span>
              }
              </app-status-alert>
            </div>
          }
          @if (orderingPossible && additionalIncomingMovementInfo.etdChanged) {
            <div>
              <app-status-alert type="info">
                <span>ETD of {{ entryDependency.vesselName }} has been changed. You may want to order the incoming movement</span>@if (etaPbpIsBeforeEtdBerth) {
                <span>, but you might have to change your ETA PBP then.</span>
              }
              </app-status-alert>
            </div>
          }
          @if (orderingPossible && additionalIncomingMovementInfo.etaChanged) {
            <div>
              <app-status-alert type="info">
                <span>ETA of {{ entryDependency.vesselName }} has been changed. You may want to order the incoming movement</span>@if (etaPbpIsBeforeEtdBerth) {
                <span>, but you might have to change your ETA PBP then.</span>
              }
              </app-status-alert>
            </div>
          }
        }
      }
      <!-- FIRST MOVEMENT IS NOT 'ORDERED', AUTO ORDER IS 'OFF' Scenario #1 -->
      <!-- FIRST MOVEMENT IS 'ORDERED', AUTO ORDER IS 'OFF' Scenario #2 -->
      <!-- AUTO ORDER IS 'ON' Scenario #3 -->
      <!--  Order of depending vessel got cancelled or rejected -->
      @if (orderCancelledOrRejected) {
        <div>
          <app-status-alert type="warning">The movement of {{ entryDependency.vesselName }} has been cancelled.
            @if (!portEntryIsOrdered) {
              <span>The incoming movement had not been ordered yet; no action required.</span>
            }
            @if (portEntryIsOrdered) {
              <span>You may want to cancel your order of the incoming movement.</span>
            }
          </app-status-alert>
        </div>
      }
      <!-- Order of depending vessel is on hold -->
      @if (dependentVesselOnHold) {
        <div>
          <app-status-alert type="warning">The movement of {{ entryDependency.vesselName }} is on hold.
          </app-status-alert>
        </div>
      }
    </div>
  }

</div>
